import { INVALIDATE as AUTH_INVALIDATE } from '@/store/actions/auth';
import { UPDATE, RESET } from '@/store/actions/rides/preview';

export const initialState = {
    // keep track of ride being previewed
    rideId: null,

    // Current location within the ride preview
    currentRoutePoint: null,

    // Current data for the ride preview
    currentRouteData: null,

    // Position in the selected route as percent
    currentRouteProgress: 0,

    // Captures the user's natural scroll instinct
    initialScroll: 0,

    // Captures the initial map center and zoom
    initialMap: null,

    // Force app to zoom in after initial scrub
    forceZoom: false,

    // Controls if the ride sidebar is open
    dropdownOpen: true,

    // Weather information based on the currentRoutePoint
    forecast: null,

    // Date and time for traffic and weather data
    datetime: {
        date: undefined,
        time: undefined
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case UPDATE: {
            const { field, value } = action.data;
            return {
                ...state,
                [field]: value
            };
        }

        case RESET: {
            return initialState;
        }

        case AUTH_INVALIDATE: {
            return initialState;
        }

        default: {
            return state;
        }
    }
};
